import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading || user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center text-[color:var(--acd-muted)]">
                A carregar...
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }
    return children;
};

export default ProtectedRoute;
